import styled from '@emotion/styled/macro';

import { linkWithUnderlineHover } from 'styles/mixins';
import { breakpoints } from 'styles/basic';
import { css } from '@emotion/react';

interface AreaProps {
  area?: string | undefined;
}
interface IconProps {
  hasSongList?: boolean;
}

const Wrapper = styled.div`

`;

const List = styled.ul`
  margin: 0;
  list-style: none;
`;

const ListItem = styled.li`
  display: flex;
  flex-flow: column wrap;
  justify-content: stretch;
  padding: 1rem 2rem 1rem 0;
  border-radius: .5rem;

  &:nth-of-type(2n) {
    background: #d3dae9;
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    flex-flow: row nowrap;
  }
`;

const NumberWrapper = styled.div`
  flex-shrink: 0;
  width: 3rem;
  margin-right: 1rem;
  text-align: right;

  @media (min-width: ${breakpoints.portraitTablet}) {
    width: 4rem;
  }
`;

const DateWrapper = styled.div`
  margin-right: 1rem;
  font-weight: bold;
  color: ${(props) => props.theme.mainColors.primary};
  white-space: nowrap;

  @media (min-width: ${breakpoints.portraitTablet}) {
    &::after {
      content: '/';
      margin-left: 1rem;
    }
  }
`;

const Name = styled.div`
  position: relative;
`;

const ConcertName = styled.div`
  display: flex;
  align-items: center;

  a {
    display: block;
    ${(props) => linkWithUnderlineHover(Name, 2, props.theme.mainColors.primary)};
  }
  span:nth-of-type(2) {
    display: block;
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    a {
      display: flex;
      align-items: baseline;
    }
  }
`;

const TourDetailsList = styled.ul`
  margin: 0 0 2rem;
  list-style: none;
`;

const TourDetailsListItem = styled.li`
  & + & {
    margin-top: .5rem;
  }
  a {
    font-weight: bold;
    color: ${(props) => props.theme.mainColors.primary};
    ${(props) => linkWithUnderlineHover('&', 2, props.theme.mainColors.primary)};
  }
`;

const TourAreaWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: .5rem;
`;

const TourArea = styled.span<AreaProps>`
  font-weight: bold;
  text-transform: uppercase;

  ${(props) => props.area === 'japan' && css`
    color: #f55043;
  `};
  ${(props) => props.area === 'asia' && css`
    color: #ae6ee7;
  `};
  ${(props) => props.area === 'europe' && css`
    color: ${props.theme.color.blue};
  `};
  ${(props) => props.area === 'north_america' && css`
    color: #46cf83;
  `};
  ${(props) => props.area === 'south_america' && css`
    color: #3c29d8;
  `};

  &:not(:last-of-type)::after {
    content: ',';
    font-weight: initial;
    color: initial;
  }
`;

const TourDescription = styled.div`

`;

const Icon = styled.div<IconProps>`
  display: flex;
  align-items: center;
  margin-left: 1rem;
  font-size: 2rem;
  color: #aeb3bf;

  ${(props) => props.hasSongList && css`
    color: ${props.theme.color.blue};
  `};
`;

export {
  Wrapper,
  List,
  ListItem,
  NumberWrapper,
  DateWrapper,
  ConcertName,
  Name,
  TourDetailsList,
  TourDetailsListItem,
  TourAreaWrapper,
  TourArea,
  TourDescription,
  Icon
};
